import { useEffect } from "react";

// Formulaire à moitié rempli : la flèche retour demande confirmation avant de quitter
let dirty = false;

export function confirmLeave() {
  return !dirty || window.confirm("Quitter sans enregistrer ?");
}

export function useUnsavedChanges(isDirty) {
  useEffect(() => {
    dirty = Boolean(isDirty);
    return () => { dirty = false; };
  }, [isDirty]);
}
